import api from "@/api";

export function formatPrice(n) {
  if (n == null || isNaN(Number(n))) return "$0";
  return "$" + Number(n).toLocaleString();
}

/**
 * Navigate the SPA to the embedded checkout page. No redirect to Stripe-hosted —
 * the /checkout/:tierId route renders the embedded form in-app.
 * Caller can pass an optional `navigate` function (react-router) for SPA-safe
 * navigation; falls back to window.location for callers without router context.
 */
export function startCheckout(tierId, navigate) {
  if (!tierId) return;
  const path = `/checkout/${encodeURIComponent(tierId)}`;
  if (typeof navigate === "function") {
    navigate(path);
  } else {
    window.location.assign(path);
  }
}

/** Called from inside the embedded checkout page to get the Stripe client_secret. */
export async function createEmbeddedSession(tierId) {
  const origin = window.location.origin;
  const { data } = await api.post("/api/payments/checkout", {
    tier_id: tierId,
    origin_url: origin,
  });
  return data; // { client_secret, session_id, publishable_key }
}

export async function fetchCatalog() {
  const { data } = await api.get("/api/payments/tiers");
  return data;
}

export async function fetchMyEntitlements() {
  const { data } = await api.get("/api/payments/me");
  return data;
}
